import { render } from "@/components/pages/immobilizer/imbGetNoOfRegKeysType1_2/IMBGetNoOfRegKeysType1_2.html?vue&type=template&id=6b3a4a56&external"
import script from "@/components/pages/immobilizer/imbGetNoOfRegKeysType1_2/IMBGetNoOfRegKeysType1_2.js?vue&type=script&lang=js&external"
export * from "@/components/pages/immobilizer/imbGetNoOfRegKeysType1_2/IMBGetNoOfRegKeysType1_2.js?vue&type=script&lang=js&external"

import "@/components/pages/immobilizer/imbGetNoOfRegKeysType1_2/IMBGetNoOfRegKeysType1_2.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__